export class GradPlanningTransferMetricCtrl {}
